import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MapPageComponent } from "../maps/pages/map-page.component";

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: MapPageComponent,
      }
    ])
  ],
  exports: [RouterModule]
})
export class LorenMapRoutingModule {
}
